import moment from "moment/moment";

/* eslint react/display-name: 0 */
/* eslint react/prop-types: 0 */
/* eslint react/no-multi-comp: 0 */
export const columns = [
  {
    Header: "Data utworzenia",
    id: "createdAt",
    accessor: b => b.createdAt ? moment(b.createdAt).local().format('DD.MM.YYYY HH:mm') : '',
    width: 140,
    Filter: () => null,
    sortable: true,
  },
  {
    Header: "Opis",
    id: "description",
    accessor: (b) => b.description,
    width: 400,
    Filter: () => null,
  },
  {
    Header: "Url",
    id: "url",
    accessor: (b) => b.url,
    width: 300,
    Filter: () => null,

  }
];
